<aside class="sidenav">
  <div class="sidenav-header">
    <div class="nav-heading">
      {{ CONSTANTS.DASHBOARD_NAV_TITLE | translate }}
    </div>
    <button pButton type="button" icon="pi pi-times" class="p-button-rounded p-button-text sidenav-close"
      (click)="closeSidebar()" aria-label="Close menu"></button>
  </div>

  @for (item of navItems; track item.route) {
  <a [routerLink]="item.route" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
    class="nav-item">
    <i [class]="item.icon"></i>
    <span>{{ item.label | translate }}</span>
  </a>
  }
</aside>